// extracted by mini-css-extract-plugin
export default {"clientMenuContainer":"ClientMenuIconStyles_clientMenuContainer__qtflt","clientMenuIcon":"ClientMenuIconStyles_clientMenuIcon__MFlJU"};